import { Check, Star } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { waLink, imgUrl } from "@/lib/api";

const inr = (n) => "₹" + n.toLocaleString("en-IN");

export function Packages({ packages }) {
  return (
    <section id="packages" className="px-5 py-16 scroll-mt-16">
      <div className="mx-auto max-w-6xl">
        <Reveal>
          <Overline>Catering menus</Overline>
          <h2 className="font-serif text-4xl sm:text-5xl tracking-tight text-primary mt-3">Choose your spread</h2>
          <p className="mt-3 text-sm text-muted-foreground max-w-md">
            Per-plate packages, fully customisable. Minimum quantity 200 persons · prices exclusive of taxes.
          </p>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-5">
          {packages.map((p, i) => {
            const message =
              `Hi The Quisine! I'm interested in the ${p.name} catering package (${inr(p.price)}/plate). Please share a quote.`;
            return (
              <Reveal key={p.id} delay={i * 0.08}>
                <div
                  data-testid={`package-card-${p.name.toLowerCase()}`}
                  className={`relative h-full flex flex-col rounded-3xl border overflow-hidden ${
                    p.featured ? "border-primary bg-primary text-primary-foreground" : "border-border bg-card"
                  }`}
                >
                  {p.image_path && (
                    <div className="relative aspect-[16/10] overflow-hidden">
                      <img src={imgUrl(p.image_path)} alt={p.name} loading="lazy" className="w-full h-full object-cover" />
                      {p.save_amount > 0 && (
                        <span
                          data-testid={`package-save-${p.name.toLowerCase()}`}
                          className="absolute top-3 right-3 rounded-full bg-accent px-3 py-1 text-xs font-bold text-accent-foreground shadow-sm"
                        >
                          Save {inr(p.save_amount)}/plate
                        </span>
                      )}
                    </div>
                  )}
                  <div className="p-6 sm:p-7 flex flex-col flex-1">
                    {p.featured && (
                      <span className="inline-flex w-fit items-center gap-1 rounded-full bg-accent px-3 py-1 text-xs font-semibold text-accent-foreground mb-3">
                        <Star className="w-3 h-3 fill-current" /> Most popular
                      </span>
                    )}
                    <h3 className="font-serif text-3xl tracking-tight">{p.name}</h3>
                    <p className={`text-sm mt-1 ${p.featured ? "text-primary-foreground/70" : "text-muted-foreground"}`}>
                      {p.tagline}
                    </p>
                    <div className="mt-5 flex items-end gap-1">
                      <span className="font-serif text-5xl">{inr(p.price)}</span>
                      <span className={`mb-1 text-sm ${p.featured ? "text-primary-foreground/70" : "text-muted-foreground"}`}>
                        {p.per_person ? "/ plate" : ""}
                      </span>
                    </div>
                    <p className={`mt-1 text-xs ${p.featured ? "text-primary-foreground/70" : "text-muted-foreground"}`}>
                      {p.suitable}
                    </p>

                    <ul className="mt-5 space-y-2.5 flex-1">
                      {p.includes.map((it, idx) => (
                        <li key={idx} className="flex items-start gap-2 text-sm">
                          <Check className={`w-4 h-4 mt-0.5 shrink-0 ${p.featured ? "text-accent" : "text-primary"}`} />
                          <span>{it}</span>
                        </li>
                      ))}
                    </ul>

                    <a
                      data-testid={`package-quote-${p.name.toLowerCase()}`}
                      href={waLink(message)}
                      target="_blank"
                      rel="noreferrer"
                      className={`mt-6 py-4 rounded-full font-medium grid place-items-center active:scale-[0.99] transition-transform ${
                        p.featured ? "bg-primary-foreground text-primary" : "bg-primary text-primary-foreground"
                      }`}
                    >
                      Request Quote
                    </a>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
